<template>
  <div class="x-misscenlist-box" style="margin:15px">
    <div class="x-miss-title">任务名称：{{misstitle}}</div>
    <el-table :data="misslist" style="width: 100%;text-align:center" ref="multipleTable" border v-loading="allmainproloading">
      <!-- <el-table-column type="index" width="50">
      </el-table-column> -->
      <el-table-column label="学员" width="70px">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-if="scope.row.username != null">{{ scope.row.username }}</span>
          <span style="margin-left: 10px" v-else></span>
        </template>
      </el-table-column>
      <el-table-column label="查看考试答案" width="">
        <template slot-scope="scope">
          <router-link :to="{name:'examfinish',params:{id:misslistid,memberId:scope.row.memberid}}" class="x-text-see">查看</router-link>

        </template>
      </el-table-column>



      <el-table-column label="查看考生视频" width="">
        <template slot-scope="scope">
          <div class="" v-if="scope.row.epid==0">
            未考试
          </div>
          <div class="" v-if="scope.row.epid!=0">
            <div class="" style="display:flex;justify-content:center">

              <video controls="controls" :src="scope.row.video" class="avatar video-avatar" style="margin:0;" v-if="scope.row.video!=''" height="100px;" width="100px"></video>

              <span class="x-ex-lce" v-if="scope.row.video==''" style="margin-right:12px;">未上传</span>

              <span style="margin-left: 10px;align-self:center" v-if="scope.row.video_score!=0">分数：{{ scope.row.video_score }}</span>

              <div  v-if="scope.row.video_score==0" class="x-ex-lce" @click="dialogVisible=true;scoreid=scope.row.epid" style="align-self:center">打分</div>
            </div>


            <div class="" style="display:flex">
              <!-- <video controls="controls" :src="scope.row.video" class="avatar video-avatar" style="margin:0;" v-if="scope.row.video!=''" height="100px;" width="100px"></video> -->

            </div>

          </div>
        </template>
      </el-table-column>


      <el-table-column label="点评" width="">
        <template slot-scope="scope">

          <div class="" v-if="scope.row.epid==0">未考试</div>
          <div class="" v-if="scope.row.epid!=0">
            <div  class="x-ex-lce" @click="dialogVisibletwo=true;dianpingid = scope.row.score;evaluateid=scope.row.epid;num='';textarea=''" v-if="scope.row.comment==''"> 点评</div>
            <div class="" v-if="scope.row.comment!=''">
              <div class="">
                最终分数：{{scope.row.update_score}}
              </div>
              <div class="">
                评价：{{scope.row.comment}}
              </div>
            </div>
          </div>

        </template>
      </el-table-column>

      <!-- <el-table-column label="点评" width="">
        <template slot-scope="scope">
          <div class="" v-if="scope.row.epid==0">
              未考试
          </div>
          <div class="" v-if="scope.row.epid!=0">
            <span style="margin-left: 10px" v-if="scope.row.comment!=''">分数：{{ scope.row.comment }}</span>
            <span class="x-ex-lce" v-if="scope.row.comment==''" @click="dialogVisibletwo=true;evaluateid=scope.row.epid">点评</span>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="成绩" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.epid==0">未考试</span>
          <span style="margin-left: 10px" v-else>{{ scope.row.score }}分
            <span v-if="scope.row.is_pass==1">(已通过)</span>
            <span v-else>(未通过)</span>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="">
        <template slot-scope="scope">
          <router-link :to="{name:'userdetails',params:{userid:scope.row.memberid,username:scope.row.username}}" class="x-text-see" @click="seeuser(scope.row.memberid)">查看详情</router-link>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pagesize"
      layout="total, prev, pager, next, jumper"
      :total="misslist.length"
      background class="x-pagination">
    </el-pagination> -->
    <!--二级查看弹窗-->
    <el-dialog
      title="打分"
      :visible.sync="dialogVisible"
      width="50%">
      <el-rate v-model="ratescore" @change="getratescore"></el-rate>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="gobranch">打 分</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="点评"
      :visible.sync="dialogVisibletwo"
      width="50%">
      <el-form class="x-dian-ping">

        <el-form-item label="修改考试结果">
          <!-- <template slot-scope="scope"> -->
          <el-input-number v-model="num" @change="handleChange" :min="parseInt(dianpingid)" :max="100" label="描述文字"></el-input-number>
          <!-- </template> -->
        </el-form-item>
        <el-form-item label="点评考试">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="textarea">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibletwo = false">取 消</el-button>
        <el-button type="primary" @click="goevaluate">点 评</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'missioncenterlist',
  data () {
    return {
      misslist:[],
      misslistid:'',
      allmainproloading:true,
      currentPage:1,//默认显示第几页
      pagesize:20,//每页个数
      misstitle:'',
      addbranch:false,
      userdone:'',
      userundone:'',
      noshowmodal:false,
      dialogVisible:false,
      ratescore:null,
      score:'',
      scoreid:'',
      dialogVisibletwo:false,
      evaluateid:'',//评价id
      textarea:'',
      num:'',
      dianpingid:1
    }
  },
  created() {
    console.log('任务中心详细id：'+this.$route.params.missid);
    console.log('任务中心详细标题：'+this.$route.params.misstitle);
    this.misslistid = this.$route.params.missid;
    this.misstitle = this.$route.params.misstitle;
    this.misscenlist()
  },
  methods:{
    //
    handleChange:function(vaal){
      // console.log(vaal);
    },
    //获得分数
    getratescore:function(val){
      console.log(val);
      this.score = val;
    },
    //确认打分
    gobranch:function(){
      axios.get('/admin/examine/videoScore', {
        params: {
          sec: localStorage.token,
          id:this.scoreid,
          score:this.score
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.$message({
              showClose: true,
              message: '打分成功',
              type: 'success'
            });
            this.dialogVisible = false;
            this.misscenlist()
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    //确认点评
    goevaluate:function(){
      if(this.textarea==''){
        this.$message({
          showClose: true,
          message:'请输入点评内容' ,
          type: 'error'
        });
      }else{
        axios.get('/admin/examine/cmt', {
          params: {
            sec: localStorage.token,
            id:this.evaluateid,
            comment:this.textarea,
            score:this.num
          }
        })
        .then(function (response) {
          console.log(response);
          if(response.data.status == 1){
              this.$message({
                showClose: true,
                message: '点评成功',
                type: 'success'
              });
              this.dialogVisibletwo = false;
              this.misscenlist()
          }else{
            this.$message({
              showClose: true,
              message:response.data.msg ,
              type: 'error'
            });
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    seetask(){

    },
    misscenlist(){
      axios.get('/admin/examine/complete', {
        params: {
          sec: localStorage.token,
          id:this.misslistid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false;
            console.log(response.data.data);
            this.misslist = response.data.data;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    handleCurrentChange(val){
      console.log(`当前页: ${val}`);
    },
    // 查看学员
    seeuser(id){
      this.addbranch = true;
      console.log(id);
      axios.get('/learn/task/memberTaskList', {
        params: {
          sec: localStorage.token,
          memberId:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.userdone = response.data.data.list.done;
            this.userundone = response.data.data.list.undone;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style>
.x-misscenlist-box .el-table th.is-leaf{
  text-align: center;
}.x-misscenlist-box .el-table thead tr th{
  background-color: #F2F2F2;
}.x-misscenlist-box .el-table td{
  text-align: center;
}.x-pagination{
  margin-top: 20px;
}.x-miss-title{
  text-align: left;
  font-size: 14px;
  padding-bottom: 20px;
}.x-ex-lce{
  color: #BDA17A;
  cursor: pointer;
}.x-dian-ping .el-form-item__content{
  display: flex;
}
</style>
<style media="screen">

</style>



// WEBPACK FOOTER //
// src/components/examcenterlist.vue